export default "__VITE_ASSET__DlJF3vFO__"